// context/VitalsContext.jsx
import React, { createContext, useContext, useState } from "react";
import { fetchVitals } from "../utils/patients/fetchVitals";
import useProfileStore from "../store/patient/profileStore";
import { useAuth } from "./AuthContext";

const VitalsContext = createContext();

export const VitalsProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [vitals, setVitals] = useState([]);
  const { profile } = useProfileStore();
  const { user } = useAuth();

  const redirectToLogin = (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("tokenV2");
      localStorage.removeItem("userId");
      window.location.href = "/pages/signin2";
    }
  };

  const handleFetchVitals = async () => {
    const patientId = user?.id || profile?.id;
    if (!patientId) return;

    setLoading(true);
    try {
      const res = await fetchVitals(patientId);
      setVitals(Array.isArray(res?.data) ? res.data : []);
    } catch (err) {
      redirectToLogin(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <VitalsContext.Provider
      value={{
        vitals,
        loading,
        handleFetchVitals,
      }}
    >
      {children}
    </VitalsContext.Provider>
  );
};

export const useVitals = () => {
  const context = useContext(VitalsContext);
  if (!context) {
    throw new Error("useVitals must be used within a VitalsProvider");
  }
  return context;
};
